import { DashboardPage } from './dashboard/DashboardPage'

/**
 * `manager-dashboard` — the first screen anybody opens, on both of the paths legacy serves it on.
 *
 * One page, two routes: legacy's `App.tsx` mounts `<Route path="/" component={Dashboard} />` and
 * `<Route path="/dashboard" component={Dashboard} />` as two entries rather than a redirect, so both are
 * mounted here too. A redirect would change what the address bar says after a login.
 *
 * **The guard is legacy's, and it is wrong in a way this module does not get to fix.** The sidebar gates
 * *Prehľad* on the permission `dashboard`, which `role_permissions` grants to all five roles; the three
 * endpoints behind the page are `@RequirePermission({"statistics", "statistics_view"})`, which only
 * `main_admin` holds — and `RequirePermission` admits `admin` unconditionally. So a cook, a waiter and a
 * driver pass the route gate and are refused by every request behind it, measured as 403 on all three.
 *
 * Narrowing the route flag would take the app's landing page off three roles' menus and leave them logging
 * in to a refusal; widening the endpoints would show the day's takings to a driver. Both are the owner's
 * call (FB-172), so the gate stays as legacy has it and the page says plainly why it is empty.
 */
export const managerDashboardModule = {
  name: 'manager-dashboard',
  routes: [
    {
      path: '/',
      page: 'dashboard',
      guard: { permission: 'dashboard' },
      component: DashboardPage,
    },
    {
      path: '/dashboard',
      page: 'dashboard',
      guard: { permission: 'dashboard' },
      component: DashboardPage,
    },
  ],
} as const

export { DashboardPage }
